import api from "./axios";

export const listAdminTickets = (params = {}) => api.get("/tickets", { params });
export const adminTicketStats = (params = {}) => api.get("/tickets/stats", { params });
export const ticketStats = adminTicketStats;
export const getAdminTicket = (id) => api.get(`/tickets/${id}`);
export const assignAdminTicket = (id, employee_id) =>
  api.patch(`/tickets/${id}/assign`, { employee_id });
export const unassignAdminTicket = (id) => api.patch(`/tickets/${id}/unassign`);
export const updateAdminTicketStatus = (id, status) =>
  api.patch(`/tickets/${id}/status`, { status });
export const updateAdminTicketPriority = (id, priority) =>
  api.patch(`/tickets/${id}/priority`, { priority });
export const sendAdminTicketMessage = (id, message) =>
  api.post(`/tickets/${id}/messages`, { message });
export const deleteAdminTicket = (id) => api.delete(`/tickets/${id}`);
